export function insertGtagScript(history) {
    var s1 = document.createElement('script');
    s1.async = true;
    s1.src = 'https://www.googletagmanager.com/gtag/js?id=G-2JMSTKNS68';
    var s2 = document.createElement('script');
    s2.innerHTML = "window.dataLayer = window.dataLayer || [];\nfunction gtag(){dataLayer.push(arguments);}\ngtag('js', new Date());\ngtag('config', 'G-2JMSTKNS68', {\n  send_page_view: false\n});";
    document.head.insertBefore(s1, document.head.childNodes[0]);
    document.head.insertBefore(s2, document.head.childNodes[1]);
    var prevPath = null;
    // https://developers.google.com/analytics/devguides/collection/gtagjs/pages#manual_pageviews
    function pageView() {
        if (prevPath === history.location.pathname) {
            return;
        }
        prevPath = history.location.pathname;
        window.gtag('event', 'page_view', {
            page_path: history.location.pathname,
        });
    }
    history.listen(function () {
        pageView();
    });
    pageView();
}
